import React from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';

function LegalNoticePage() {
  const { config } = useSiteConfig();
  const owner = config?.legal_owner_name || config?.legal_business_name || 'KREEO';
  const business = config?.legal_business_name || 'KREEO';
  const nif = config?.legal_nif || '[NIF pendiente]';
  const address = config?.legal_address || 'Barcelona, España';
  const email = config?.legal_email || config?.contact_email || 'ton@kreeo.es';
  const phone = config?.legal_phone || config?.contact_phone || '';
  const registry = config?.legal_registry || '';

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="legal-notice-page">
      <h1 className="text-4xl font-light text-[#374963] mb-8">Aviso Legal</h1>
      <div className="space-y-6 text-[#374963] leading-relaxed">
        <p className="text-sm text-[#73706e]">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

        <section>
          <h2 className="text-2xl font-semibold mb-3">1. Datos identificativos</h2>
          <p>
            En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio,
            de Servicios de la Sociedad de la Información y del Comercio Electrónico, se informa:
          </p>
          <ul className="mt-2 space-y-1">
            <li><strong>Titular:</strong> {owner}</li>
            <li><strong>Denominación comercial:</strong> {business}</li>
            <li><strong>NIF / CIF:</strong> {nif}</li>
            <li><strong>Domicilio:</strong> {address}</li>
            <li><strong>Correo electrónico:</strong> {email}</li>
            {phone && <li><strong>Teléfono:</strong> {phone}</li>}
            {registry && <li><strong>Datos registrales:</strong> {registry}</li>}
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">2. Objeto</h2>
          <p>
            El presente aviso legal regula el uso del sitio web <strong>{typeof window !== 'undefined' ? window.location.hostname : 'kreeo.es'}</strong>,
            del que es titular {owner}. La navegación por este sitio web atribuye la condición de usuario del mismo e implica la aceptación plena
            de todas las cláusulas contenidas en este aviso legal.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">3. Propiedad intelectual</h2>
          <p>
            Todos los contenidos del sitio web (textos, imágenes, diseños gráficos, código fuente, logotipos, marcas, etc.)
            son propiedad de {owner} o cuenta con la debida autorización para su uso. Queda expresamente prohibida su reproducción,
            distribución, comunicación pública y transformación total o parcial sin autorización expresa del titular.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">4. Condiciones de uso</h2>
          <p>
            El usuario se compromete a utilizar el sitio web de forma diligente y respetando la legalidad vigente,
            la buena fe y el presente aviso legal. Queda prohibido el uso del sitio con fines ilícitos o lesivos.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">5. Exclusión de responsabilidad</h2>
          <p>
            {owner} no se hace responsable de los daños y perjuicios que pudieran derivarse del uso del sitio web ni
            de la falta de disponibilidad temporal por causas de fuerza mayor. Se reserva el derecho a modificar, sin previo
            aviso, el contenido del sitio.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">6. Legislación aplicable</h2>
          <p>
            El presente aviso legal se rige por la legislación española. Para cualquier controversia derivada del uso del sitio,
            las partes se someten a los Juzgados y Tribunales del domicilio del titular, salvo que la ley aplicable disponga otra cosa.
          </p>
        </section>
      </div>
    </div>
  );
}

export default LegalNoticePage;
